class TabDebut

  activeClass: 'is-active'

  constructor: (@elm) ->
    @$elm = $ @elm
    @$button = @$elm.find 'li'
    @$content = $ '.js-tab-content'
    @$content.hide().eq(0).show()
    @$button.on 'click', @changeTab

  changeTab: (event) =>
    elm = event.currentTarget
    index = @$button.index elm
    @$content
      .hide()
      .eq index
      .show()
      .find '.js-debut-slider'
      .trigger 'slideReset'
    @$button.removeClass @activeClass
    elm.classList.add @activeClass

export default TabDebut



// WEBPACK FOOTER //
// ./webpack/imports/view/tab-debut.coffee